import React from "react";
import PropTypes from  "prop-types";

function LightHeroC(props) {
  return (
    <section className="text-gray-600 body-font">
      <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0">
          <img className="object-cover object-center rounded" alt="hero" src="https://dummyimage.com/720x600" />
        </div>
        <div className="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
            You are pre-approved for a loan upto <br className="hidden lg:inline-block" />
            for Rs. 1,00,000<small>.00</small>
          </h1>
          <p className="mb-8 leading-relaxed">
            You are 2 minutes from using your credit line.
          </p>
          <div className="flex justify-center">
            <button className={`inline-flex text-white bg-${props.theme}-500 border-0 py-2 px-6 focus:outline-none hover:bg-${props.theme}-600 rounded text-lg`}>
              Next
            </button>
            <button className="ml-4 inline-flex text-gray-700 bg-gray-100 border-0 py-2 px-6 focus:outline-none hover:bg-gray-200 rounded text-lg">
              Remind me later
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

LightHeroC.defaultProps = {
  theme: 'indigo'
};

LightHeroC.propTypes = {
  theme: PropTypes.string.isRequired
};

export default LightHeroC;
